export default "__VITE_ASSET__04a69ff5__"